// 🧿 طلسم محافظ فایل

// Utilities
import { getTable } from "./requestTemplates";
import { AxiosRequestConfig } from "axios";
// Types
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { Report } from "src/Interfaces/TableInterfaces";
import type {
  IPortfoMonitoringSearchParam,
  PortfoMonitoringReport,
} from "src/Interfaces/portfoMonitoring";
/**
 * Covered Call => option domain
 * مانیتورینگ پورتفو
 *
 * @param {IOptionDomainSearchParam} searchParam
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getPortfoMonitoringTable = (
  searchParam: IPortfoMonitoringSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<PortfoMonitoringReport>> =>
  getTable<IPortfoMonitoringSearchParam, PortfoMonitoringReport>(
    "/v1/Portfo/PortfolioMonitoringTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );
